import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { X } from 'lucide-react-native';
import { memo } from 'react';
import { TouchableOpacity, View } from 'react-native';
import { aiColors } from '../../../../../ai-suite/theme';

/** A dimmed suggestion near the controls; dismissible. */
export const HintLine = memo(
  ({ hint, onDismiss }: { hint: string; onDismiss: () => void }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          gap: rpx(8),
          paddingHorizontal: rpx(16),
          opacity: 0.75,
        }}
      >
        <Typography.Text
          size={rpx(13)}
          color={aiColors.mutedForeground}
          style={{ flex: 1, textAlign: 'center' }}
        >
          {`💡 试试：${hint}`}
        </Typography.Text>
        <TouchableOpacity
          accessibilityRole="button"
          accessibilityLabel="收起提示"
          onPress={onDismiss}
          hitSlop={8}
        >
          <X size={rpx(14)} color={aiColors.mutedForeground} />
        </TouchableOpacity>
      </View>
    );
  },
);
